<template>
  <div>
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'client-branches'
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/index.vue